import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { setCurrentNavPage } from "Actions";
import { fetchPublicPortal } from "Thunks";

import Subheader from "./Subheader";
import Infos from "./Infos";
import News from "./News";
import Team from "./Team";
import Docs from "./Docs";
import Contact from "./Contact";

//import { default as CommunityAdmin } from "./admin/Community";

class PublicPortal extends Component {
  componentDidMount() {
    const {
      navCommunity,
      push,
      setCurrentNavPage,
      fetchPublicPortal
    } = this.props;
    // if (navCommunity && navCommunity.id) {
    //   push(`/public/${navCommunity.url}/${navCommunity.id}`);
    // }
    setCurrentNavPage("HOME_PAGE");
    fetchPublicPortal();
  }

  render() {
    const { page } = this.props;
    if (!page) {
      return <div id="portal-home" />;
    }
    const community = page.organization;

    return (
      <div id="portal-home">
        <Subheader blocs={page.details} community={community} />
        {page.details.media.activated && <Infos community={community} />}
        {page.details.news.activated && <News community={community} />}
        {page.details.team.activated && <Team community={community} />}
        {page.details.documents.activated && <Docs community={community} />}
        {page.details.contact.activated && (
          <Contact community={community} bloc={page.details.contact} />
        )}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  navCommunity: state.auth.navCommunity,
  params: state.params,
  community: state.params.publicPortal.community,
  page: state.params.publicPortal.page
});

const mapDispatchToProps = dispatch => ({
  push: url => dispatch(push(url)),
  setCurrentNavPage: navPage => dispatch(setCurrentNavPage(navPage)),
  fetchPublicPortal: () => dispatch(fetchPublicPortal())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicPortal);



// WEBPACK FOOTER //
// ./src/components/PublicPortal/index.js